/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { createColumnHelper } from '@tanstack/react-table';
import { getDate } from '../../../../helpers/catalogHelpers';
import { TableHeader } from '@GxT-Team/gxt-components';
import { DataSourceType } from '../../types';
import { ProjectSortParams, SortOrderType } from '../../../../services/api/types';
import { formatVariableKeys, getUserFullName } from '../../../../helpers/utils';
import { DataSourceTabs } from '../../types';

export const generateColumns = (
  handleColumnSort: (sort: SortOrderType, column: keyof ProjectSortParams) => void,
  sortedColumn: { column: string; order: SortOrderType },
) => {
  const dataSourceColumnHelper = createColumnHelper<DataSourceType>();

  const getRequiredVariablesLabel = (row: DataSourceType) => {
    if (Array.isArray(row.dataSourceVariables) && row.dataSourceVariables.length > 0) {
      return formatVariableKeys(row.dataSourceVariables);
    }

    if (row.catalogItems && typeof row.catalogItems === 'object') {
      return Object.keys(row.catalogItems).join(', ');
    }

    return '';
  };

  const createTableHeader = (
    title: string,
    accessor = '',
    activeColumn = { column: '', order: 'ASC' as SortOrderType },
  ) => {
    return () => (
      <TableHeader
        ColumnName={accessor}
        Title={title}
        handleColumnSort={handleColumnSort as (sort: SortOrderType, column: string) => void}
        activeColumn={activeColumn}
      />
    );
  };

  const columns: Record<DataSourceTabs, any[]> = {
    [DataSourceTabs.DATA_SOURCE]: [
      dataSourceColumnHelper.accessor('id', {
        header: createTableHeader('ID', 'id', sortedColumn),
        cell: (info) => info.getValue(),
        size: 10,
      }),
      dataSourceColumnHelper.accessor('name', {
        header: createTableHeader('Query Name', 'name', sortedColumn),
        cell: (info) =>
          info.getValue() || info.row.original.title || info.row.original.documentName || '',
        size: 709,
      }),
      dataSourceColumnHelper.accessor('type', {
        header: createTableHeader('Type', 'type', sortedColumn),
        cell: (info) => info.getValue() || info.row.original.documentType || '',
        size: 109,
      }),
      dataSourceColumnHelper.accessor('dataSourceVariables', {
        header: createTableHeader('Required Variables', 'dataSourceVariables', sortedColumn),
        cell: (info) => getRequiredVariablesLabel(info.row.original),
        size: 209,
      }),
      dataSourceColumnHelper.accessor('createdAt', {
        header: createTableHeader('Created On', 'createdAt', sortedColumn),
        cell: (info) => {
          const createdAt = info.row.original.createdAt;
          return createdAt && getDate(createdAt);
        },
        size: 126,
      }),
      dataSourceColumnHelper.accessor('user', {
        header: createTableHeader('Owner', 'user', sortedColumn),
        cell: (info) =>
          getUserFullName(info.row.original.createdBy || info.row.original.user || null),
        size: 260,
      }),
    ],
  };

  return columns[DataSourceTabs.DATA_SOURCE];
};
